import { Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Routes } from '@angular/router';
import { JhiPaginationUtil, JhiResolvePagingParams } from 'ng-jhipster';
import { UserRouteAccessService } from 'src/app/core';
import { Observable } from 'rxjs';
import { ClauseExtensionMySuffix } from 'src/app/shared/model/clause-extension-my-suffix.model';
import { ClauseExtensionMySuffixService } from './clause-extension-my-suffix.service';
import { ClauseExtensionMySuffixComponent } from './clause-extension-my-suffix.component';
import { ClauseExtensionMySuffixDetailComponent } from './clause-extension-my-suffix-detail.component';
import { ClauseExtensionMySuffixUpdateComponent } from './clause-extension-my-suffix-update.component';
import { ClauseExtensionMySuffixDeletePopupComponent } from './clause-extension-my-suffix-delete-dialog.component';
import { IClauseExtensionMySuffix } from 'src/app/shared/model/clause-extension-my-suffix.model';

@Injectable({ providedIn: 'root' })
export class ClauseExtensionMySuffixResolve implements Resolve<IClauseExtensionMySuffix> {
    constructor(private service: ClauseExtensionMySuffixService) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const id = route.params['id'] ? route.params['id'] : null;
        if (id) {
            return this.service.find(id).map((clauseExtension: HttpResponse<ClauseExtensionMySuffix>) => clauseExtension.body);
        }
        return Observable.of(new ClauseExtensionMySuffix());
    }
}

export const clauseExtensionRoute: Routes = [
    {
        path: 'clause-extension',
        component: ClauseExtensionMySuffixComponent,
        resolve: {
            pagingParams: JhiResolvePagingParams
        },
        data: {
            authorities: [
                'ROLE_USER',
                'ROLE_ADMIN',
                'ADMIN_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'AUDIT_USER',
                'AUDIT_USER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF'
            ],
            defaultSort: 'id,asc',
            pageTitle: 'ClauseExtensions'
        },
        canActivate: [UserRouteAccessService]
    },
    {
        path: 'clause-extension/:id/view',
        component: ClauseExtensionMySuffixDetailComponent,
        resolve: {
            clauseExtension: ClauseExtensionMySuffixResolve
        },
        data: {
            authorities: [
                'ROLE_USER',
                'ROLE_ADMIN',
                'ADMIN_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'AUDIT_USER',
                'AUDIT_USER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF'
            ],
            pageTitle: 'ClauseExtensions'
        },
        canActivate: [UserRouteAccessService]
    },
    {
        path: 'clause-extension/new',
        component: ClauseExtensionMySuffixUpdateComponent,
        resolve: {
            clauseExtension: ClauseExtensionMySuffixResolve
        },
        data: {
            authorities: [
                'ROLE_USER',
                'ROLE_ADMIN',
                'ADMIN_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF'
            ],
            pageTitle: 'ClauseExtensions'
        },
        canActivate: [UserRouteAccessService]
    },
    {
        path: 'clause-extension/:id/edit',
        component: ClauseExtensionMySuffixUpdateComponent,
        resolve: {
            clauseExtension: ClauseExtensionMySuffixResolve
        },
        data: {
            authorities: [
                'ROLE_USER',
                'ROLE_ADMIN',
                'ADMIN_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF'
            ],
            pageTitle: 'ClauseExtensions'
        },
        canActivate: [UserRouteAccessService]
    }
];

export const clauseExtensionPopupRoute: Routes = [
    {
        path: 'clause-extension/:id/delete',
        component: ClauseExtensionMySuffixDeletePopupComponent,
        resolve: {
            clauseExtension: ClauseExtensionMySuffixResolve
        },
        data: {
            authorities: [
                'ROLE_USER',
                'ROLE_ADMIN',
                'ADMIN_STAFF',
                'BROKER',
                'BROKER_STAFF',
                'UNDERWRITER',
                'UNDERWRITER_STAFF',
                'INSURER',
                'INSURER_STAFF'
            ],
            pageTitle: 'ClauseExtensions'
        },
        canActivate: [UserRouteAccessService],
        outlet: 'popup'
    }
];
